// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teleDriversHeaderSection {
  display: flex;
  justify-content: space-between;
  padding: 22px 0px 12px;
  align-items: center;
  border-top: 1px solid #28304C;
  margin: 0 20px;
  min-width: 450px;
}
.teleDriversHeaderSection .MuiBox-root {
  display: flex;
  align-items: center;
}
.teleDriversHeaderSection .MuiBox-root img {
  margin-right: 10px;
}
.teleDriversHeaderSection .MuiBox-root span {
  font-size: 20px;
  font-family: "Poppins";
  font-weight: 700;
  line-height: 18.3px;
}
.teleDriversHeaderSection .StatusDropdown .MuiInputBase-root {
  width: 181px;
  background: #2B3045;
  border-radius: 10px;
  padding: 10px 14px 10px 0px;
  height: 50px;
  border: none;
  box-shadow: unset;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 21px;
  font-family: "Poppins";
}
.teleDriversHeaderSection .StatusDropdown .MuiInputBase-root fieldset {
  border: unset;
}
.teleDriversHeaderSection .StatusDropdown .MuiInputBase-root svg.MuiSvgIcon-root {
  color: rgba(255, 255, 255, 0.7);
}
.teleDriversHeaderSection .StatusDropdown .MuiInputBase-root img {
  cursor: pointer;
}

.MuiPaper-root {
  border-radius: 10px !important;
  border: 1px solid #2B3045 !important;
  box-shadow: 0px 0px 25.3px 0px rgba(0, 0, 0, 0.28) !important;
  background: #202437 !important;
  margin-top: 6px;
  min-width: 180px !important;
}
.MuiPaper-root .MuiMenu-list {
  padding: unset !important;
}
.MuiPaper-root .MuiMenu-list li {
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #fff;
  padding: 12px 10px !important;
}
.MuiPaper-root .MuiMenu-list .view-text {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  padding: 5px 10px !important;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/TeleDriversSection/TeleDriverHeaderSection/styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;AAER;AAAQ;EACI,kBAAA;AAEZ;AACQ;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AACZ;AAIQ;EACI,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAFZ;AAIY;EACI,aAAA;AAFhB;AAKY;EACI,+BAAA;AAHhB;AAMY;EACI,eAAA;AAJhB;;AAUA;EACI,8BAAA;EACA,oCAAA;EACA,6DAAA;EACA,8BAAA;EACA,eAAA;EACA,2BAAA;AAPJ;AAQI;EACI,yBAAA;AANR;AAOQ;EACI,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;AALZ;AAQQ;EACI,+BAAA;EACA,eAAA;EACA,4BAAA;EACA,oBAAA;AANZ","sourcesContent":[".teleDriversHeaderSection {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 22px 0px 12px;\r\n    align-items: center;\r\n    border-top: 1px solid #28304C;\r\n    margin: 0 20px;\r\n    min-width: 450px;\r\n    .MuiBox-root {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        img {\r\n            margin-right: 10px;\r\n        }\r\n\r\n        span {\r\n            font-size: 20px;\r\n            font-family: 'Poppins';\r\n            font-weight: 700;\r\n            line-height: 18.3px;\r\n        }\r\n    }\r\n\r\n    .StatusDropdown {\r\n        .MuiInputBase-root {\r\n            width: 181px;\r\n            background: #2B3045;\r\n            border-radius: 10px;\r\n            padding: 10px 14px 10px 0px;\r\n            height: 50px;\r\n            border: none;\r\n            box-shadow: unset;\r\n            color: rgba(255, 255, 255, 0.7);\r\n            font-size: 14px;\r\n            line-height: 21px;\r\n            font-family: 'Poppins';\r\n\r\n            fieldset {\r\n                border: unset;\r\n            }\r\n\r\n            svg.MuiSvgIcon-root {\r\n                color: rgba(255, 255, 255, 0.7);\r\n            }\r\n\r\n            img {\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.MuiPaper-root{\r\n    border-radius: 10px !important;\r\n    border: 1px solid #2B3045 !important;\r\n    box-shadow: 0px 0px 25.3px 0px rgba(0, 0, 0, 0.28) !important;\r\n    background: #202437 !important;\r\n    margin-top: 6px;\r\n    min-width: 180px !important;\r\n    .MuiMenu-list{\r\n        padding: unset !important;\r\n        li {\r\n            font-family: 'Poppins';\r\n            font-size: 14px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: 22px;\r\n            color: #fff;\r\n            padding: 12px 10px !important;\r\n        }\r\n            \r\n        .view-text {\r\n            color: rgba(255, 255, 255, 0.40);\r\n            font-size: 12px;\r\n            padding: 5px 10px !important;\r\n            pointer-events: none;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
